import { useEffect, useState } from "react";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { getFormattedDateDDMMMYYYYDate } from "../../../../utilities/dateFunctions/formatdate";
import { formatINRCurrency } from "../../../../utilities/currency/currency";
import { axiosPrivate } from "../../../../api/axios";
import { GET_LOANEE_MINI_STATEMENT_URL } from "../../../../api/api_routing_urls";

const MiniStatementLedger = ({ basicDetails, setMiniStatementDetails }) => {
  const { loanappliedamt, loan_first_disbursment_date, loan_number } =
    basicDetails;
  const [list, setList] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const payload = {
          loan_number: loan_number,
        };
        const res = await axiosPrivate.post(
          GET_LOANEE_MINI_STATEMENT_URL,
          payload
        );
        console.log(res?.data?.response);
        setList(res?.data?.response || []);
        setMiniStatementDetails(res?.data?.response);
      } catch (error) {
        console.error("Not able to get mini statement", error);
      }
    })();
  }, []);

  return (
    <>
      <TableWrapper>
        <thead className="bg-slate-200 text-sm my-3 sticky top-0">
          <tr>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Sl No.
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Date
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Repayment Amount
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Interest Due
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Interest Paid
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Balance
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100 text-slate-700 text-xs">
          {/* Disbusement details */}
          <tr>
            <td className="px-3 ps-7 py-2 whitespace-nowrap">1</td>
            <td className="px-3 py-2 whitespace-nowrap">
              {getFormattedDateDDMMMYYYYDate(loan_first_disbursment_date)}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(loanappliedamt) || 0}
            </td>
          </tr>
          {list?.length > 0 ? (
            list?.map((data, index) => (
              <tr
                key={index}
                className={index % 2 === 1 ? "bg-slate-100" : null}
              >
                <td className="px-3 ps-7 py-2 whitespace-nowrap">
                  {index + 2}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {getFormattedDateDDMMMYYYYDate(data?.tr_date)}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.amount) || 0}
                </td>

                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.interest_due) || 0}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.interest_paid) || 0}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.balance) || 0}
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={8} className="p-4 text-center">
              {" "}
              No Record Found
            </td>
          )}
        </tbody>
      </TableWrapper>
    </>
  );
};

export default MiniStatementLedger;
